const getLocalIsoDate = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const hasEventEnded = (event) => {
  const endDate = event?.endDate ?? event?.eventEndDate;
  const endDateOnly = typeof endDate === 'string' ? endDate.slice(0, 10) : '';

  return /^\d{4}-\d{2}-\d{2}$/.test(endDateOnly) && endDateOnly < getLocalIsoDate();
};

export const isEventEffectivelyActive = (event) => Boolean(event?.isActive) && !hasEventEnded(event);

export const getEventStatusLabel = (event) => {
  if (event?.hasPendingEdit === true) {
    return 'W trakcie zatwierdzania';
  }

  if (event?.isRejectedByAdmin === true) {
    return 'Odrzucone';
  }

  if (event?.isApprovedByAdmin === false) {
    return 'Oczekujące';
  }

  if (hasEventEnded(event)) {
    return 'Zakończone';
  }

  return Boolean(event?.isActive) ? 'Aktywne' : 'Nieaktywne';
};

export const getEventStatusClassName = (event) => {
  if (event?.hasPendingEdit === true || (event?.isApprovedByAdmin === false && event?.isRejectedByAdmin !== true)) {
    return 'event-status event-status--pending';
  }

  if (event?.isRejectedByAdmin === true) {
    return 'event-status event-status--rejected';
  }

  if (hasEventEnded(event)) {
    return 'event-status event-status--ended';
  }

  if (!event?.isActive) {
    return 'event-status event-status--inactive';
  }

  return 'event-status event-status--active';
};
